<div class="Nav-Bar">
  <div class="Body container-global-components">
    <div class="Body__Container">
      <div class="Body__Container--Image">
        <img src="./assets/Global/Ilustrations/Not_Permission.png" alt="" />
      </div>
      <div class="Body__Container--Title">Sin acceso a la librería</div>
      <div class="Body__Container--Subtitle">
        {{ GetGreeting() }}, {{ NameUser() }}, Actualmente, no dispone de acceso
        a la librería. Si presenta algún inconveniente relacionado con
        este acceso, le solicitamos ponerse en contacto con su supervisor.
      </div>
      <div class="Body__Container--Button">
        <button class="btn-icon-text">
          <a routerLink="/Dashboard/General/HomeSystemCDMS"></a>
          <span class="text">Home</span><i class="fa-solid fa-house"></i>
        </button>
      </div>
    </div>
  </div>
</div>
